export default __webpack_public_path__ + "static/media/NotoSansKR-Bold.bbb4ca5d.otf";